import { render, staticRenderFns } from "./CustomerCreditReport.vue?vue&type=template&id=45cd4f50&"
import script from "./CustomerCreditReport.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditReport.vue?vue&type=style&index=0&id=45cd4f50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports